<template>
  <div>
    <b-row align="left">
      <b-col md="6" class="mt-2">
        <p class="mb-1 font-weight-bold">
          <font class="h4 text-primary">Voucher</font>
        </p>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="2" class="pr-0">
        <b-button
          block
          @click="tab_menu = 'universal'"
          :variant="tab_menu === 'universal' ? '': 'light'"
          :class="tab_menu === 'universal' ? 'bg-primary text-white':'bg-white text-primary'"
          size="lg"
        >Universal</b-button>
      </b-col>
      <b-col md="2" class="pl-0">
        <b-button
          block
          @click="tab_menu = 'non_universal'"
          :variant="tab_menu === 'non_universal' ? '': 'light'"
          :class="tab_menu === 'non_universal' ? 'bg-primary text-white':'bg-white text-primary'"
          class="border-light"
          size="lg"
        >Non-Universal</b-button>
      </b-col>
    </b-row>
    <b-row>
      <transition name="fade" mode="out-in">
        <b-col v-if="tab_menu === 'universal'" class="mt-4" md="12" :key="1">
          <universal-voucher></universal-voucher>
        </b-col>
        <b-col v-else md="12" class="mt-4" :key="2">
          <non-universal-voucher></non-universal-voucher>
        </b-col>
      </transition>
    </b-row>
  </div>
</template>

<script>
const UniversalVoucher = () => import("./component/userapp/UniversalVoucher");
const NonUniversalVoucher = () => import("./component/NonUniversalVoucher");

export default {
  components: {
    universalVoucher: UniversalVoucher,
    nonUniversalVoucher: NonUniversalVoucher,
  },
  data() {
    return {
      tab_menu: "universal",
    }
  },
};
</script>
